import React from 'react'
import { Link } from 'react-router-dom'
import { IoMdAdd, IoMdClose, IoMdRemove } from 'react-icons/io'
import { useDispatch } from 'react-redux'
import { decreaseQuantity, deleteOneProduct, increaseQuantity } from '../action'


function CartItem({ item }) {
    const { id, title, price, currency, imageUrl, imageUrls, quantity, stock } = item
    const resolvedCurrency = currency || 'ARS'
    const displayPrice = Number(price)
    const dispatch = useDispatch()

    // Función para obtener la imagen correcta
    const getImageSrc = () => {
        // Priorizar imageUrls[0], luego imageUrl como fallback
        if (imageUrls && imageUrls.length > 0) {
            const url = imageUrls[0];
            return url.startsWith('http') ? url : `http://localhost:4200${url}`;
        } else if (imageUrl) {
            return imageUrl.startsWith('http') ? imageUrl : `http://localhost:4200${imageUrl}`;
        }
        return 'https://images.pexels.com/photos/1464625/pexels-photo-1464625.jpeg?auto=compress&cs=tinysrgb&w=400';
    }

    const handleRemove = (id) => {
        dispatch(deleteOneProduct(item))
    }
    const increaseAmount = () => {
        if (quantity < stock) {
            dispatch(increaseQuantity(item))
        } else {
            alert('No hay más stock disponible para este producto')
        }
    }

    const decreaseQ = (id) => {
        dispatch(decreaseQuantity(item))
    }

    return (
        <div className='flex flex-col gap-y-3 py-3 lg:px-6 border-b border-slate-200 w-full font-light text-slate-600 z-index-31'>
            <div className='w-full min-h-[130px] flex flex-col sm:flex-row sm:items-center gap-4'>
                <Link to={`/producto/${id}`}>
                    <img
                        className='max-w-[80px] h-[80px] object-cover rounded-md border border-slate-200'
                        src={getImageSrc()}
                        alt={title || "Producto"}
                    />
                </Link>
                <div className='w-full flex flex-col min-w-0'>
                    <div className='flex justify-between gap-2 mb-2 min-w-0'>
                        <Link to={`/producto/${id}`} className='text-sm uppercase font-medium text-slate-800 hover:underline break-words pr-2 min-w-0'>{title}</Link>
                        <div onClick={handleRemove} className='text-xl cursor-pointer'>
                            <IoMdClose className='text-slate-500 hover:text-red-500 transition' />
                        </div>
                    </div>
                    <div className='flex flex-col sm:flex-row flex-wrap gap-2 sm:gap-x-2 text-sm'>
                        <div className='flex flex-1 max-w-[130px] items-center h-[34px] border border-slate-200 text-slate-700 font-medium'>
                            <div onClick={decreaseQ} className='flex-1 flex justify-center items-center cursor-pointer h-full'>
                                <IoMdRemove />
                            </div>
                            <div className='h-full flex justify-center items-center px-2'>
                                {quantity}
                            </div>
                            <div onClick={increaseAmount} className='flex-1 h-full flex justify-center items-center cursor-pointer'>
                                <IoMdAdd />
                            </div>
                        </div>
                        <div className='flex-1 min-w-[80px] flex flex-col items-start text-slate-600'>
                            <span className="price-old text-xs">{resolvedCurrency === 'USD' ? 'US$' : '$'} {Number(displayPrice * 2).toLocaleString('es-AR')}</span>
                            <span>{resolvedCurrency === 'USD' ? 'US$' : '$'} {displayPrice}</span>
                            <span className="text-[10px] text-slate-500">{resolvedCurrency}</span>
                        </div>
                        <div className='flex-1 min-w-[80px] flex flex-col items-start sm:items-end text-slate-800 font-medium'>
                            <span className="price-old text-xs">{resolvedCurrency === 'USD' ? 'US$' : '$'} {Number(displayPrice * quantity * 2).toLocaleString('es-AR')}</span>
                            <span>{`${resolvedCurrency === 'USD' ? 'US$' : '$'} ${parseFloat(displayPrice * quantity).toLocaleString('es-AR')}`}</span>
                            <span className="text-[10px] text-slate-500">{resolvedCurrency}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CartItem